import IconShareInstagram from '@/components/icons/IconShareInstagram.vue';
import IconShareViber from '@/components/icons/IconShareViber.vue';
import IconShareTelegram from '@/components/icons/IconShareTelegram.vue';
import IconShareFacebook from '@/components/icons/IconShareFacebook.vue';
import IconShareEmail from '@/components/icons/IconShareEmail.vue';
import IconShareCopy from '@/components/icons/IconShareCopy.vue';

export default {
  name: 'ShareBlock',
  components: {
    IconShareCopy,
    IconShareEmail,
    IconShareFacebook,
    IconShareTelegram,
    IconShareViber,
    IconShareInstagram
  },
  props: {
    data: {
      type: String,
      default: () => {}
    },
    positionCenter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {
    sharedPageUrl() {
      return window.location.href;
    }
  },
  methods: {
    _copyLink() {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(this.sharedPageUrl);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = this.sharedPageUrl;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
    },
    onHiddenCopyLink() {
      this._copyLink();
    },
    onCopyLink() {
      this._copyLink();
      this.$toasted.success(this.$t('label.linkCopied'));
    }
  }
};
